/** Phase 9 (KI, Empfehlungen, Bedarfsprognose) — Oberflächentexte, Deutsch. Siehe ai.tr.ts; Begriffe: docs/I18N_GLOSSARY.md. */
export const aiDe = {
  ui: {
    nav: {
      group: 'KI',
      settings: 'KI-Einstellungen',
      recommendations: 'Produktempfehlungen',
      forecast: 'Bedarfsprognose',
      studio: 'Content-Studio',
      copilot: 'Copilot (Geschäftsassistent)',
      seo: 'SEO-Vorschläge',
      ltv: 'Prognostizierter Kundenwert',
      youtube: 'YouTube-Videos',
    },
    availability: {
      ready: 'Bereit',
      not_configured: 'Einrichtung erforderlich',
      disabled: 'Aus (Freigabe durch den Inhaber ausstehend)',
      budget_exhausted: 'Monatslimit erreicht',
      daily_limit: 'Tägliches Anfragelimit erreicht',
    },
    purposes: {
      product_description: 'Produktbeschreibung',
      merchant_title: 'Google-Produkttitel',
      translation: 'Übersetzung',
      article_plan: 'Artikelplan',
      article_headings: 'Artikelüberschriften',
      article_draft: 'Artikelentwurf',
      article_meta: 'SEO-Titel und -Beschreibung',
      alt_text: 'Alt-Text für Bilder',
      image: 'Bilderzeugung',
      email_draft: 'E-Mail-Entwurf',
      ad_copy: 'Anzeigentext',
      ad_suggestions: 'Werbeempfehlungen',
      support_reply: 'Support-Antwortentwurf',
      copilot: 'Copilot',
    },
    requestStatus: { pending: 'Läuft', ok: 'Abgeschlossen', error: 'Fehler' },
    providerNames: { anthropic: 'Anthropic Claude', openai: 'OpenAI Images' },
    recommendations: {
      statusTitle: 'Status',
      statusLead:
        'Empfehlungen nutzen keine KI und sind kostenlos: Sie werden jede Nacht um 04:25 Uhr aus den echten bezahlten Bestellungen des Shops berechnet. Bei zu wenigen Daten wird der Bereich in der Storefront ausgeblendet.',
      run: 'Jetzt berechnen',
      ran: '{{orders}} Bestellungen ausgewertet, {{pairs}} Beziehungen gespeichert.',
      stats: '{{pairs}} Beziehungen · {{products}} Produkte mit Empfehlungen',
      runsTitle: 'Letzte Berechnungen',
      when: 'Zeitpunkt',
      trigger: 'Gestartet von',
      scheduled: 'Nächtlicher Job',
      manualBy: 'Manuell ({{name}})',
      orders: 'Bestellungen',
      pairsKept: 'Gespeicherte / gefundene Beziehungen',
      result: 'Ergebnis',
      status: { ok: 'Abgeschlossen', error: 'Fehler' },
      noStore: 'Kein Shop',
      noStoreLead:
        'Empfehlungen werden pro Shop berechnet. Legen Sie zuerst unter Unternehmen → Shops einen Shop an.',
      noRuns: 'Noch keine Berechnungen.',
      settingsTitle: 'Einstellungen',
      toggles: {
        alsoBought: 'Produktseite: „Kunden, die dies kauften, kauften auch“',
        cart: 'Warenkorb: „Passend zu Ihrem Warenkorb“',
        replenishment: 'Mein Konto: „Zeit zum Nachbestellen“',
        includeB2b: 'Händlerbestellungen einbeziehen',
      },
      toggleHints: {
        alsoBought:
          'Produkte, die häufig in derselben Bestellung gekauft werden (Ergänzungsprodukte werden nicht doppelt angezeigt).',
        cart: 'Produkte, die häufig mit den Artikeln im Warenkorb gekauft werden; Artikel, die bereits im Warenkorb liegen, werden ausgeblendet.',
        replenishment:
          'Voraussichtliches Nachbestelldatum für regelmäßig gekaufte Produkte (nur für den Kunden selbst sichtbar).',
        includeB2b:
          'Großhandelsbestellungen können die Beziehungen im Einzelhandel verzerren; standardmäßig aus.',
      },
      windowDays: 'Ausgewerteter Zeitraum (Tage)',
      minPairBuyers: 'Mindestanzahl verschiedener Käufer',
      minPairBuyersHint:
        'Eine Beziehung wird nur verwendet, wenn sie in Bestellungen von mindestens so vielen verschiedenen Kunden vorkommt (damit sich daraus nicht die Käufe einer einzelnen Person ablesen lassen). Mindestens 2.',
      minConfidence: 'Mindest-Konfidenz (%)',
      minConfidenceHint:
        'Anteil der Käufer des Produkts, die auch das andere gekauft haben. Filtert Zufallstreffer heraus.',
      maxPerProduct: 'Maximale Empfehlungen pro Produkt',
      save: 'Einstellungen speichern',
      saved: 'Einstellungen gespeichert. Sie gelten ab der nächsten Berechnung.',
      pairsTitle: 'Stärkste Beziehungen',
      pairsLead:
        'Die stärkste Beziehung jedes Produkts. Konfidenz: Anteil der Käufer, die auch das andere Produkt gekauft haben. Lift: wie viel häufiger als zufällig beide zusammen gekauft werden (über 1).',
      product: 'Produkt',
      related: 'Zusammen gekauft',
      buyers: 'Verschiedene Käufer',
      confidence: 'Konfidenz',
      lift: 'Lift',
      noPairs: 'Noch keine Empfehlungen',
      noPairsLead:
        'Empfehlungen entstehen automatisch, sobald genügend Bestellungen vorliegen (mehrere verschiedene Kunden, die dieselben zwei Produkte zusammen kaufen).',
    },
    forecast: {
      lead: 'Nutzt keine KI: wird bei jedem Aufruf aus den wöchentlichen Verkäufen echter bezahlter, nicht stornierter Bestellungen berechnet. Noch nicht eingegangene Mengen offener Bestellungen werden vom Vorschlag abgezogen. Saison- und Aktionseffekte werden nicht berücksichtigt; es wird kein Bestellschein erstellt.',
      counts: {
        stockout: 'Ausverkauft',
        reorder: 'Nachbestellen',
        on_order: 'Bestellt',
        expiry_risk: 'MHD-Risiko',
        overstock: 'Überbestand',
        ok: 'Ausreichend',
        no_sales: 'Keine Verkäufe',
      },
      accuracy: 'Prognosefehler der letzten 4 Wochen (WAPE): {{pct}} % · {{count}} Varianten',
      accuracyNone: 'Zur Messung der Genauigkeit sind mindestens 8 Wochen Verkaufshistorie nötig.',
      totalSuggested: 'Vorgeschlagene Bestellmenge gesamt: {{count}} Stück',
      totalOnOrder: 'Bestellt und angefragt: {{count}} Stück',
      filterStatus: 'Status',
      all: 'Alle',
      search: 'Produkt oder SKU suchen',
      csv: 'CSV herunterladen',
      product: 'Produkt',
      sold28: 'Letzte 28 Tage',
      daily: 'Tagesprognose',
      available: 'Verfügbarer Bestand',
      onOrder: 'Bestellt',
      requestedNote: '{{count}} angefragt',
      cover: 'Reichweite',
      coverDays: '{{days}} Tage',
      suggested: 'Bestellvorschlag',
      status: 'Status',
      method: 'Methode',
      methods: {
        none: 'Keine Verkäufe',
        new: 'Neues Produkt (Durchschnitt)',
        ses: 'Regelmäßig (exponentielle Glättung)',
        croston: 'Sporadisch (Croston)',
      },
      expiry: 'MHD-Risiko: Charge {{lot}} am {{date}} — {{count}} Stück werden möglicherweise nicht verkauft',
      excluded: 'Von der Prognose ausgeschlossen',
      customSafety: 'Eigener Sicherheitsbestand: {{days}} Tage',
      leadLine: 'Lieferzeit {{days}} Tage ({{source}})',
      leadSources: {
        variant: 'produktspezifisch',
        supplier: 'vom Lieferanten',
        supplierNamed: 'Lieferant: {{name}}',
        default: 'Standard',
      },
      adjust: 'Anpassen',
      empty: 'Keine Produkte anzuzeigen',
      emptyLead: 'Die Liste ist leer, wenn es keine aktiven Varianten gibt oder nichts zum Filter passt.',
      variantTitle: '{{product}} — Prognoseeinstellung',
      leadTime: 'Lieferzeit (Tage)',
      safety: 'Sicherheitsbestand (Tage)',
      defaultHint: 'Leer lassen, um den Unternehmensstandard ({{days}} Tage) zu verwenden.',
      supplierHint:
        'Leer lassen, um die Lieferzeit des Lieferanten der letzten Bestellung ({{days}} Tage) zu verwenden.',
      exclude: 'Von der Prognose ausschließen (einmaliges oder ausgelaufenes Produkt)',
      variantSaved: 'Varianteneinstellung gespeichert.',
      settingsTitle: 'Standardwerte',
      historyWeeks: 'Ausgewertete Historie (Wochen)',
      defaultLead: 'Standard-Lieferzeit (Tage)',
      defaultSafety: 'Standard-Sicherheitsbestand (Tage)',
      reviewDays: 'Überprüfungszeitraum (Tage)',
      reviewHint:
        'Die vorgeschlagene Menge soll den Bedarf für Lieferzeit + Sicherheitsbestand + diesen Zeitraum decken.',
      overstockDays: 'Schwelle für Überbestand (Tage)',
      includeB2b: 'Händlerbestellungen als Bedarf zählen',
      save: 'Standardwerte speichern',
      saved: 'Standardwerte gespeichert.',
    },
    studio: {
      lead: 'Erstellen Sie einen Artikel in 27 Schritten: von Thema und Quellen zur Gliederung, vom Entwurf zu SEO und Bildern, von der Qualitätsprüfung bis zur Performance nach der Veröffentlichung. KI-Schritte sind optional; jedes Feld kann auch manuell ausgefüllt werden. Veröffentlichung sowie redaktionelle und tierärztliche Freigabe erfolgen im Bereich Blog.',
      create: 'Neues Artikelprojekt',
      createTitle: 'Neues Artikelprojekt',
      createSubmit: 'Projekt erstellen',
      filter: 'Anzeigen',
      filters: { active: 'In Bearbeitung', exported: 'In den Blog übertragen', archived: 'Archiv' },
      statuses: { draft: 'In Bearbeitung', exported: 'In den Blog übertragen', archived: 'Archiviert' },
      empty: 'Noch keine Artikelprojekte',
      emptyLead: 'Beginnen Sie mit „Neues Artikelprojekt“, indem Sie Thema und Zielgruppe eingeben.',
      words: '{{count}} Wörter',
      updated: '{{date}} · {{name}}',
      healthBadge: 'Gesundheitsbezogener Inhalt',
      aiAssisted: 'KI-gestützt',
      back: 'Alle Projekte',
      save: 'Speichern',
      saved: 'Projekt gespeichert.',
      unsaved: 'Es gibt ungespeicherte Änderungen.',
      saveFirst: 'Speichern Sie zuerst Ihre Änderungen.',
      stepsTitle: 'Ablauf: {{done}} / {{total}} Schritte',
      stepDone: 'erledigt',
      stepOpen: 'offen',
      stepAi: 'In diesem Schritt wurde KI verwendet',
      steps: {
        topic: 'Thema',
        audience: 'Zielgruppe',
        market: 'Zielland und Sprache',
        keyword: 'Keyword',
        intent: 'Suchintention',
        sources: 'Quellen',
        duplicates: 'Dublettenprüfung',
        plan: 'Artikelplan',
        headings: 'H2/H3-Überschriften',
        draft: 'Entwurf',
        sourceCheck: 'Quellenprüfung',
        internalLinks: 'Interne Links',
        relatedProducts: 'Passende Produkte',
        seoTitle: 'SEO-Titel',
        metaDescription: 'Meta-Beschreibung',
        slug: 'URL-Slug',
        category: 'Kategorie',
        tags: 'Schlagwörter',
        schema: 'Strukturierte Daten',
        cover: 'Titelbild',
        images: 'Inhaltsbilder',
        altText: 'Alt-Texte',
        quality: 'Qualitätsprüfung',
        approval: 'Redaktionelle und tierärztliche Freigabe',
        schedule: 'Veröffentlichen / planen',
        performance: 'Performance-Tracking',
        updates: 'Aktualisierungsvorschläge',
      },
      sec: {
        brief: 'Thema und Ziel (Schritte 1–5)',
        research: 'Quellen und Dublettenprüfung (Schritte 6, 7, 11)',
        outline: 'Plan und Überschriften (Schritte 8–9)',
        draft: 'Entwurf, interne Links und passende Produkte (Schritte 10, 12–13)',
        seo: 'SEO (Schritte 14–19)',
        images: 'Bilder (Schritte 20–22)',
        quality: 'Qualitätsprüfung (Schritt 23)',
        publish: 'Freigabe und Veröffentlichung (Schritte 24–25)',
        performance: 'Performance und Aktualisierungen (Schritte 26–27)',
      },
      f: {
        title: 'Arbeitstitel',
        topic: 'Thema',
        topicHint:
          'Die Frage, die der Artikel beantwortet, oder das Thema, das er behandelt (z. B. „Wie wählt man Omega-3-Nahrungsergänzung für Katzen aus?“).',
        audience: 'Zielgruppe',
        country: 'Zielland',
        countryHint: 'Zweistelliger Ländercode (TR, DE…).',
        keyword: 'Keyword',
        keywordPool: 'Aus dem Keyword-Pool wählen',
        keywordNone: 'Keines (selbst eingeben)',
        intent: 'Suchintention',
        intentNone: 'Nicht festgelegt',
        health: 'Gesundheits-/Nahrungsergänzungsinhalt (tierärztliche Freigabe erforderlich)',
        sourceUrl: 'Quell-URL',
        sourceTitle: 'Name der Quelle',
        sourceNote: 'Notiz',
        plan: 'Plan',
        headings: 'Überschriften',
        headingLevel: 'Ebene',
        headingText: 'Überschrift',
        draft: 'Entwurf (Markdown)',
        draftHint:
          '{{count}} Wörter. ## für H2, ### für H3; [Text](/urun/slug) für interne Links. Rohes HTML wird nicht ausgeführt.',
        relatedProducts: 'Passende Produkte',
        seoTitle: 'SEO-Titel',
        slug: 'Slug',
        metaDescription: 'Meta-Beschreibung',
        category: 'Blog-Kategorie',
        categoryNone: 'Ohne Kategorie',
        tags: 'Schlagwörter',
        tagsHint: 'Durch Kommas getrennt (max. 10).',
        cover: 'Titelbild',
        coverAlt: 'Alt-Text des Titelbilds',
        images: 'Inhaltsbilder',
        imageReplace: 'Bild ersetzen',
        imageAlt: 'Alt-Text',
        imageAdd: 'Bild hinzufügen',
        aiDisclosure: 'Am Ende des Artikels den Hinweis „mit KI-Unterstützung erstellt“ einfügen',
      },
      intents: {
        informational: 'Sucht Informationen',
        commercial: 'Vergleicht',
        transactional: 'Möchte kaufen',
        navigational: 'Sucht eine bestimmte Seite',
      },
      sourcesLead:
        'Fügen Sie die Quellen hinzu, auf die sich der Artikel stützt. Die KI darf nur diese zitieren; sie kann keine Quellen, Statistiken oder Studien erfinden. Die Quellen werden in den Abschnitt „Quellen“ des Blogbeitrags übernommen.',
      addSource: 'Quelle hinzufügen',
      removeSource: 'Quelle entfernen',
      verify: 'Quellen prüfen',
      verified: 'Quellen geprüft.',
      checkedAt: 'geprüft am {{date}}',
      sourceStatus: {
        ok: 'Erreichbar',
        unreachable: 'Nicht erreichbar',
        blocked: 'Blockiert (internes Netz)',
        http_error: 'Seite meldet einen Fehler',
        not_html: 'Keine Webseite',
        invalid_url: 'Ungültige URL',
      },
      duplicatesTitle: 'Dublettenprüfung',
      duplicatesNotChecked: 'Noch nicht geprüft.',
      duplicatesNone: 'Kein Beitrag und keine Seite mit ähnlichem Titel im Shop.',
      duplicatesChecked: 'Dublettenprüfung abgeschlossen.',
      similarity: '{{pct}} % ähnlich',
      checkDuplicates: 'Ähnliche Inhalte suchen',
      aiPlan: 'Plan und Überschriften mit KI',
      aiDraft: 'Entwurf mit KI',
      aiMeta: 'SEO-Vorschlag mit KI',
      aiDone: 'KI-Vorschlag gespeichert. Prüfen und bearbeiten Sie ihn.',
      overwrite: 'Überschreiben',
      overwriteConfirm:
        'Dieses Feld enthält bereits Inhalt. Der KI-Vorschlag ersetzt ihn (die alte Fassung wird nicht aufbewahrt). Fortfahren?',
      claimsFound:
        'Im Vorschlag wurden {{count}} gesundheitsbezogene Aussagen gefunden; korrigieren Sie sie vor der Veröffentlichung:',
      masked: 'Vor dem Senden an den Anbieter wurden {{count}} personenbezogene Angaben maskiert.',
      truncated: 'Die Antwort wurde an der Längengrenze abgeschnitten; prüfen Sie das Ende.',
      addHeading: 'Überschrift hinzufügen',
      removeHeading: 'Überschrift entfernen',
      linksTitle: 'Interne Links',
      linksNone: 'Noch keine internen Links ausgewählt.',
      linkTypes: { product: 'Produkt', category: 'Kategorie', post: 'Beitrag' },
      removeLink: 'Link {{title}} entfernen',
      suggest: 'Aus dem Shop vorschlagen',
      suggestNone: 'Kein veröffentlichtes Produkt, keine Kategorie und kein Beitrag passt zum Thema.',
      add: 'Hinzufügen',
      added: 'Hinzugefügt',
      relatedSuggested: 'Vorgeschlagene Produkte:',
      chars: '{{count}} / {{max}} Zeichen',
      schemaNote:
        'Strukturierte Daten (BlogPosting) werden bei der Veröffentlichung des Blogbeitrags automatisch aus Titel, Beschreibung, Titelbild und Datumsangaben erzeugt.',
      coverSet: 'Titelbild ausgewählt',
      imagesNote:
        'Das Titelbild wird zum Titelbild des Blogbeitrags; Inhaltsbilder werden mit „In Entwurf einfügen“ im Entwurf platziert und mit ihm übertragen.',
      aiCover: 'Titelbild mit KI',
      aiImage: 'Inhaltsbild mit KI',
      imagePrompt: 'Was soll das Bild zeigen?',
      imagePromptHint:
        'Kurz und konkret (z. B. „glücklicher Golden Retriever, der durch einen Park läuft, Morgenlicht“). Text, Logos, Marken oder erkennbare Personen werden nicht eingefügt.',
      imageStyle: 'Stil',
      imageStyles: { photo: 'Realistisches Foto', illustration: 'Illustration' },
      imageSize: 'Größe',
      imageSizes: {
        '1536x1024': 'Querformat (3:2)',
        '1024x1024': 'Quadratisch',
        '1024x1536': 'Hochformat (2:3)',
      },
      imageCost:
        'Kostenpflichtige Anfrage; die Kosten pro Bild überschreiten nie die Obergrenze aus den KI-Einstellungen.',
      generate: 'Bild erzeugen',
      imageDone: 'Bild erzeugt und hinzugefügt. Schreiben Sie den Alt-Text und speichern Sie.',
      aiGenerated: 'KI-generiert',
      aiAlt: 'Alt-Text mit KI',
      altDone: 'Alt-Text-Vorschlag eingetragen; gleichen Sie ihn mit dem Bild ab und speichern Sie.',
      insertToDraft: 'In Entwurf einfügen',
      inserted:
        'Bild am Ende des Entwurfs eingefügt; verschieben Sie es an die gewünschte Stelle und speichern Sie.',
      provenance: 'Quelle und Lizenz',
      provenanceTitle: 'Bildquelle und Lizenz',
      provenanceSource: 'Quelle',
      provenanceSources: {
        own: 'Eigenes Foto / eigenes Design',
        licensed: 'Lizenziert (Stockbild)',
        supplier: 'Lieferant / Marke',
        other: 'Sonstige',
        ai_generated: 'KI-generiert',
      },
      provenanceNone: 'Keine Quellenangabe.',
      provenanceLicense: 'Lizenz',
      provenanceLicenseHint: 'Z. B. „Stock-Standardlizenz“, „CC BY 4.0“.',
      provenanceCredit: 'Urheberrecht / Bildnachweis',
      provenanceUrl: 'Quell-URL',
      provenanceSaved: 'Quellenangaben gespeichert.',
      provenanceAiLocked:
        'Die Quelle eines KI-generierten Bildes kann nicht geändert werden; es wird in der Storefront mit dem Hinweis „KI-generiertes Bild“ angezeigt.',
      provenanceModel: 'Modell: {{model}} · {{date}}',
      qualityStatus: { pass: 'OK', warn: 'Warnung', fail: 'Fehlt' },
      quality: {
        title_length: 'Der Titel hat {{length}} Zeichen (empfohlen 30–70).',
        meta_length: 'Die Meta-Beschreibung hat {{length}} Zeichen (empfohlen 70–170).',
        slug: 'Slug festgelegt.',
        word_count: 'Der Entwurf hat {{words}} Wörter (mindestens {{min}}).',
        h1_in_body: 'Keine H1 im Entwurf (der Titel wird separat gesetzt).',
        h2_count: '{{count}} H2-Überschriften (mindestens 2).',
        keyword_title: 'Das Keyword kommt im Titel vor.',
        keyword_intro: 'Das Keyword kommt im Einleitungsabsatz vor.',
        keyword_heading: 'Das Keyword kommt in mindestens einer Zwischenüberschrift vor.',
        keyword_density: 'Keyword-Dichte {{percent}} % (max. 3 %).',
        keyword_missing: 'Kein Keyword festgelegt.',
        internal_links: 'Interne Links: {{count}} im Entwurf (mindestens einer empfohlen).',
        sources_missing: 'Keine Quellen (bei gesundheitsbezogenen Inhalten Pflicht).',
        sources_broken: '{{count}} Quellen nicht erreichbar.',
        sources_unchecked: '{{count}} Quellen noch nicht geprüft.',
        sources_ok: '{{count}} Quellen geprüft.',
        cover: 'Titelbild und Alt-Text.',
        image_alt: 'Bei {{count}} Bildern fehlt der Alt-Text.',
        health_claims: 'Aussagen zur Vorbeugung/Behandlung von Krankheiten: {{count}} Formulierungen.',
        duplicates_unchecked: 'Dublettenprüfung nicht durchgeführt.',
        duplicates_similar: 'Sehr ähnlicher Inhalt vorhanden: {{title}}.',
        duplicates_ok: 'Kein sehr ähnlicher Inhalt.',
        expert_review:
          'Vor der Veröffentlichung ist die Freigabe durch den Tierärztlichen Fachprüfer erforderlich.',
      },
      qualityAfterSave: 'Die Qualitätsprüfung bezieht sich auf die gespeicherte Fassung.',
      publishLead:
        'Die Übertragung legt im Blog einen Entwurf an oder aktualisiert den verknüpften Entwurf. Veröffentlichung, Freigabe durch Redaktion und Tierärztlichen Fachprüfer sowie geplante Veröffentlichung erfolgen im Bereich Blog; der veröffentlichte Beitrag ändert sich durch die Übertragung nicht.',
      export: 'In Blogbeitrag übertragen',
      reexport: 'Blog-Entwurf aktualisieren',
      exported: 'Blog-Entwurf aktualisiert.',
      openPost: 'Blogbeitrag öffnen',
      archive: 'Projekt archivieren',
      archiveConfirm: 'Projekt archivieren? Der verknüpfte Blogbeitrag ist davon nicht betroffen.',
      archivedDone: 'Projekt archiviert.',
      perf: {
        not_exported:
          'Die Performance wird angezeigt, nachdem der Artikel in den Blog übertragen und veröffentlicht wurde.',
        not_live: 'Der Blogbeitrag ist noch nicht veröffentlicht.',
        no_permission: 'Sie dürfen keine Search-Console-Daten einsehen.',
        not_linked:
          'Search Console ist nicht verbunden (Einrichtung erforderlich): Verbinden Sie sie im Bereich Google-Verbindungen.',
        no_data: 'Die Search-Console-Daten wurden noch nicht synchronisiert.',
      },
      perfRange: 'Neueste Daten: {{from}} – {{to}}',
      perfPeriod: 'Zeitraum',
      periods: { current: 'Letzte 28 Tage', previous: 'Vorherige 28 Tage' },
      clicks: 'Klicks',
      impressions: 'Impressionen',
      ctr: 'Klickrate',
      position: 'Durchschnittliche Position',
      notComparable: 'Für den Vorzeitraum liegen nicht genug Daten vor.',
      queries: 'Suchanfragen, die zu diesem Beitrag führen (letzte 28 Tage)',
      queryStats: '· {{clicks}} Klicks · {{impressions}} Impressionen',
      suggestionsTitle: 'Aktualisierungsvorschläge',
      suggestionsNone: 'Derzeit keine Vorschläge.',
      suggestions: {
        stale: 'Seit {{days}} Tagen nicht aktualisiert; prüfen Sie Fakten und Quellen.',
        traffic_drop:
          'Die Klicks sind gegenüber den vorherigen 28 Tagen gesunken ({{previous}} → {{current}}). Prüfen Sie Suchanfragen und Aktualität.',
        low_ctr:
          'Klickrate {{ctr}} % bei {{impressions}} Impressionen: Formulieren Sie SEO-Titel und Meta-Beschreibung aussagekräftiger.',
        near_first_page:
          'Durchschnittliche Position {{position}}: nahe der ersten Seite. Erweitern Sie den Inhalt und verlinken Sie ihn von passenden Seiten.',
        missing_queries:
          'Im Beitrag nicht abgedeckte Suchanfragen: {{queries}}. Ergänzen Sie bei Bedarf einen Abschnitt.',
        sources_recheck: 'Die Quellen wurden seit 6 Monaten nicht geprüft; prüfen Sie die Links erneut.',
      },
    },
    drafts: {
      copy: 'Kopieren',
      copied: 'Kopiert.',
      generate: 'Entwurf erzeugen',
      again: 'Erneut erzeugen',
      apply: 'In Felder übernehmen',
      applied: 'Entwurf ins Formular übernommen; prüfen und speichern Sie ihn.',
      reviewNote:
        'Dies ist ein Entwurf, der nur auf den gespeicherten Produktdaten beruht. Lesen Sie ihn vor der Veröffentlichung; gesundheitsbezogene Inhalte durchlaufen die tierärztliche Freigabe.',
      productDescription: 'Beschreibungsentwurf mit KI',
      productLead:
        'Kurz- und Langbeschreibung werden aus den gespeicherten Produktdaten geschrieben (Name, Marke, Tierart, Kategorie, Merkmale, Zusammensetzung, Anwendung, Warnhinweise). Kostenpflichtige Anfrage.',
      tone: 'Tonalität',
      tones: { informative: 'Informativ', friendly: 'Freundlich' },
      notes: 'Hervorzuhebender Punkt (optional)',
      translate: 'Mit KI übersetzen',
      translateFrom: 'Ausgangssprache',
      translated: 'Übersetzung ins Formular übernommen; prüfen und speichern Sie sie.',
      email: 'Betreffideen mit KI',
      goal: 'Kampagnenziel',
      goalHint: 'Z. B. „Kunden im Winter an Produkte zur Gelenkunterstützung erinnern“.',
      audience: 'Zielgruppe (optional)',
      products: 'Hervorgehobene Produkte (optional)',
      subjects: 'Betreffideen',
      useAsA: 'Als Betreff verwenden',
      useAsB: 'Als Betreff B verwenden',
      preheader: 'Preheader',
      use: 'Verwenden',
      intro: 'Einleitungsabsatz',
      introNote: 'Sie können den Einleitungsabsatz in den Text der E-Mail-Vorlage kopieren.',
      supportReply: 'Antwortentwurf mit KI',
      replyDone: 'Antwortentwurf eingetragen; lesen und bearbeiten Sie ihn, bevor Sie ihn senden.',
      adSuggestions: 'Werbeempfehlungen',
      adSuggestionsLead:
        'Regelbasierte Befunde auf Basis echter Bestellumsätze (kostenlos). Optional fasst die KI die Befunde nur anhand dieser Zahlen zusammen (kostenpflichtig). Budget- und Auslieferungsänderungen laufen immer über eine Änderungsanfrage mit Genehmigung.',
      period: 'Zeitraum',
      lastDays: 'Letzte {{days}} Tage',
      findings: 'Befunde anzeigen',
      summarize: 'Mit KI zusammenfassen',
      noAdData:
        'Keine Werbedaten in diesem Zeitraum. Verbinden Sie ein Werbekonto oder laden Sie eine Berichtsdatei hoch.',
      noFindings: 'Keine Befunde, die Aufmerksamkeit erfordern.',
      findingKinds: {
        no_orders: 'Ausgaben ohne Bestellungen',
        roas_below_1: 'ROAS unter 1',
        low_ctr: 'Niedrige CTR',
        scale_candidate: 'Skalierbar',
        anomaly: 'Auffälligkeit',
      },
      anomalies: {
        no_clicks: 'Ausgaben ohne Klicks',
        spend_spike: 'Ausgabenspitze',
        ctr_drop: 'CTR gesunken',
        sync_failed: 'Synchronisierungsfehler',
        sync_stale: 'Daten nicht aktuell',
      },
      aiSummary: 'KI-Zusammenfassung',
      adChangeNote:
        'Nur eine Empfehlung: Es wird keine Anzeige erstellt, und weder Budget noch Status werden geändert. Erstellen Sie eine Änderungsanfrage und reichen Sie sie zur Genehmigung ein.',
      adCopy: 'Anzeigentext-Entwurf',
      product: 'Produkt',
      platform: 'Plattform',
      platforms: { google: 'Google (responsive Suchanzeige)', meta: 'Meta (Facebook / Instagram)' },
      pickProduct: 'Wählen Sie zuerst ein Produkt aus.',
      primaryTexts: 'Primärtexte',
      headlines: 'Überschriften',
      descriptions: 'Beschreibungen',
      maxChars: 'max. {{max}} Zeichen',
      dropped: '{{count}} Zeilen wurden verworfen, weil sie das Zeichenlimit überschritten.',
      adEmpty: 'Kein verwendbarer Text',
      adEmptyLead: 'Erzeugen Sie die Texte erneut.',
    },
    copilot: {
      lead: 'Aus Ihren Daten berechnete Erkenntnisse (kostenlos, ohne KI) und ein Assistent, der mit diesen Daten antwortet. Copilot ändert keine Datensätze; es werden nur Daten verwendet, die Sie einsehen dürfen.',
      period: 'Zeitraum',
      copyReport: 'Als Managementbericht kopieren',
      reportTitle: 'Management-Zusammenfassung ({{from}} – {{to}})',
      insightsTitle: 'Erkenntnisse',
      noInsights: 'Noch keine Erkenntnisse',
      noInsightsLead: 'Sie erscheinen hier, sobald Verkaufs-, Bestands- oder Werbedaten vorliegen.',
      severity: { good: 'Gut', info: 'Info', warn: 'Achtung' },
      sectionsNote: 'Mangels Berechtigung ausgelassene Bereiche: {{hidden}}.',
      sections: {
        stock: 'Bestand',
        seo: 'SEO',
        customers: 'Kundensegmente',
        ads: 'Werbung',
        cost: 'Kosten und Marge',
        finance: 'Nettogewinn',
      },
      insights: {
        no_sales:
          'Weder in diesem noch im Vorzeitraum gibt es bezahlte Bestellungen; keine Erkenntnis zum Verkauf möglich.',
        revenue_change:
          'Produktumsatz {{current}} (Vorzeitraum {{previous}}, Veränderung {{change}} %); {{orders}} Bestellungen (Vorzeitraum {{previousOrders}}).',
        aov_change:
          'Durchschnittlicher Warenkorb {{current}} (Vorzeitraum {{previous}}, Veränderung {{change}} %).',
        decline_drivers: 'Produkte mit dem größten Anteil am Rückgang: {{products}}.',
        refund_rate: 'Erstattungs-/Stornoquote {{rate}} %: Prüfen Sie die Rücksendegründe.',
        new_customers: '{{share}} % der Bestellungen stammen von Neukunden ({{count}} Bestellungen).',
        margin_down:
          'Rohertragsmarge {{previous}} % → {{current}} %: Prüfen Sie Kostensteigerungen oder Rabatte.',
        margin_unknown: 'Marge nicht verfügbar: Für einige verkaufte Produkte sind keine Kosten hinterlegt.',
        quiet_days:
          'Bestellungen nur an {{active}} von {{days}} Tagen dieses Zeitraums; der Vorzeitraum war gleichmäßiger.',
        stock_needs: '{{stockout}} Varianten ausverkauft, {{reorder}} müssen nachbestellt werden: {{items}}.',
        expiry_risk: 'Bei {{count}} Varianten droht Bestand, der bis zum MHD nicht verkauft werden kann.',
        seo_not_linked: 'Search Console ist nicht verbunden; SEO-Chancen können nicht berechnet werden.',
        seo_opportunities:
          'Suchanfragen nahe der ersten Seite, aber selten geklickt (Impressionen, Position): {{queries}}.',
        segment_at_risk:
          '{{count}} wertvolle Kunden drohen verloren zu gehen (RFM „Gefährdet“ und „Dürfen nicht verloren gehen“): Erwägen Sie eine Rückgewinnungskampagne.',
        segment_champions:
          '{{count}} Champion-Kunden: Laden Sie sie zu Treue- oder Empfehlungsprogrammen ein.',
        ads_roas: 'Werbeausgaben {{spend}}, Produktumsatz aus Werbung {{revenue}} (ROAS {{roas}}).',
        ads_anomalies: '{{count}} Auffälligkeiten bei der Werbung: Prüfen Sie das Werbecenter.',
        net_profit:
          'Nettogewinn {{current}} (Vorzeitraum {{previous}}, Veränderung {{change}} %); Nettomarge {{margin}} %.',
        net_profit_partial:
          'Nettogewinn mit unvollständigen Daten berechnet: Umsatz ohne Kosten {{revenue}}, {{shipments}} Sendungen ohne Versandkosten, {{payments}} Zahlungen ohne Gebühr (Berichte → Finanzbericht).',
      },
      salesTitle: 'Umsatzübersicht ({{from}} – {{to}})',
      metric: 'Kennzahl',
      current: 'Dieser Zeitraum',
      previous: 'Vorzeitraum',
      metrics: {
        orders: 'Bestellungen',
        revenue: 'Produktumsatz (ohne MwSt. und Versand)',
        refunded: 'Erstattungen / Stornierungen',
        newCustomers: 'Neukunden',
      },
      topProducts: 'Bestseller',
      profitTitle: 'Nettogewinn ({{from}} – {{to}})',
      profitLead:
        'Gleiche Berechnung wie im Finanzbericht: ohne MwSt., in türkischen Lira. Nettogewinn = Bruttogewinn − Versand − Zahlungsgebühren − Werbung − verlorene Rückbuchungen − Betriebsausgaben.',
      profitMetrics: {
        revenueMinor: 'Produktumsatz (ohne MwSt.)',
        grossProfitMinor: 'Bruttogewinn',
        shippingMinor: 'Versandkosten',
        feesMinor: 'Zahlungsgebühren',
        adsMinor: 'Werbeausgaben',
        disputesMinor: 'Verlorene Rückbuchungen',
        expensesMinor: 'Betriebsausgaben',
        netProfitMinor: 'Nettogewinn',
        netBps: 'Nettomarge',
      },
      percent: '{{value}} %',
      askTitle: 'Copilot fragen',
      askLead:
        'Antworten stützen sich nur auf die oben berechneten Daten (es werden keine Kundennamen, E-Mail-Adressen oder Anschriften gesendet). Fehlen Daten, sagt Copilot das; er führt nie Aktionen aus. Jede Frage ist eine kostenpflichtige Anfrage.',
      conversation: 'Unterhaltung',
      you: 'Sie',
      copilot: 'Copilot',
      question: 'Ihre Frage',
      questionHint:
        'Z. B. „Warum ist der Umsatz gesunken?“, „Welche Produkte sollte ich nachbestellen?“, „Drei Empfehlungen für diesen Monat, bitte.“',
      ask: 'Fragen',
      clear: 'Unterhaltung löschen',
    },
    seo: {
      lead: 'Vorschläge ohne KI aus Ihrem Keyword-Pool und Ihren Search-Console-Daten: automatische Cluster, Themenlandkarte, Long-Tail-Suchanfragen, Inhaltslücken und Google-Produkttitel.',
      notSynced:
        'Keine Search-Console-Daten: Impressionen und Long-Tail-Vorschläge bleiben leer. Verbinden Sie die Search Console im Bereich Google-Verbindungen.',
      clustersTitle: 'Automatische Cluster',
      noProposals: 'Keine neuen Cluster vorzuschlagen.',
      emptyPool: 'Der Keyword-Pool ist leer. Fügen Sie Keywords unter SEO-Center → Keywords hinzu.',
      keywordCount: '({{count}} Keywords)',
      applyClusters: '{{count}} ausgewählte Cluster übernehmen',
      applied: 'Cluster für {{count}} Keywords aktualisiert.',
      topicsTitle: 'Themenlandkarte (Pillar- und unterstützende Inhalte)',
      noTopics: 'Keine Keywords mit Cluster. Übernehmen Sie zuerst Cluster.',
      pillar: 'Haupt-Keyword: {{keyword}} → {{path}}',
      noPage: 'keine Seite',
      link: {
        yes: 'Verlinkt auf die Pillar-Seite',
        no: 'Link zur Pillar-Seite fehlt',
        unknown: 'Nicht geprüft',
      },
      missingContent: '{{count}} Keywords haben keine Zielseite.',
      longTailTitle: 'Long-Tail-Suchanfragen',
      noLongTail: 'Keine Suchanfrage mit 3+ Wörtern und 10+ Impressionen außerhalb des Pools.',
      query: 'Suchanfrage',
      pick: '{{query}} auswählen',
      addToPool: '{{count}} ausgewählte Suchanfragen zum Pool hinzufügen',
      added: 'Zum Pool hinzugefügt.',
      gapsTitle: 'Inhaltslücken',
      noGaps: 'Jedes Keyword hat eine Zielseite.',
      createProject: 'Artikelprojekt erstellen',
      openProject: 'Projekt öffnen',
      titlesTitle: 'Google-Produkttitel',
      titlesLead:
        'Der an das Merchant Center gesendete Titel: max. 150 Zeichen, wichtigste Informationen zuerst, Marke und Produktart, kein Werbetext und keine durchgehenden Großbuchstaben. Bleibt er leer, wird der Produktname gesendet.',
      onlyIssues: 'Nur mit Problemen',
      noTitleIssues: 'Keine Titelprobleme.',
      currentTitle: 'Aktueller Titel',
      suggested: 'Vorschlag',
      aiSuggested: 'KI-Vorschlag',
      applyTitle: 'Übernehmen',
      aiTitle: 'Titel mit KI',
      resetTitle: 'Produktnamen verwenden',
      titleSaved: 'Google-Titel gespeichert; er gilt ab dem nächsten Feed-Upload.',
      issues: {
        too_long: 'Über 150 Zeichen',
        too_short: 'Zu kurz',
        promo_text: 'Werbetext',
        all_caps: 'Nur Großbuchstaben',
        brand_missing: 'Marke fehlt',
        symbols: 'Unnötige Symbole / Emojis',
        health_claim: 'Gesundheitsbezogene Aussage',
      },
    },
    youtube: {
      lead: 'Die öffentlichen Angaben der YouTube-Videos in Produkten und Blogbeiträgen werden über die YouTube Data API gelesen (nur Lesezugriff, kostenloses Tageskontingent; keine KI). Die Storefront erhält Videoinformationen für Suchmaschinen (Vorschaubild, Upload-Datum, Dauer); entfernte, nicht einbettbare oder in der Türkei gesperrte Videos werden in der Storefront nicht angezeigt.',
      connectionTitle: 'Verbindung',
      notConfigured:
        'Noch kein Schlüssel für die YouTube Data API. Videos werden in der Storefront weiterhin wie bisher angezeigt; es fehlen nur Videodetails und Warnungen.',
      connectionError:
        'Der YouTube-Schlüssel wurde abgelehnt oder die API ist deaktiviert. Prüfen Sie den Schlüssel im Bereich Integrationen und testen Sie erneut.',
      toIntegrations: 'Schlüssel im Bereich Integrationen eingeben',
      connected: 'Verbunden',
      lastSync: 'Letzte Synchronisierung: {{date}}',
      neverSynced: 'Noch nicht synchronisiert (läuft jede Nacht um 05:50 Uhr).',
      syncNow: 'Jetzt synchronisieren',
      synced: 'Details von {{count}} Videos aktualisiert.',
      logsTitle: 'Letzte Synchronisierungen',
      outcome: { success: 'Erfolgreich', failure: 'Fehler', blocked: 'Blockiert' },
      logOk: '{{videos}} Videos, {{requests}} Anfragen',
      videosTitle: 'Verwendete Videos',
      noVideos: 'Keine YouTube-Videos in Produkten oder Blogbeiträgen.',
      summary: '{{count}} Videos · {{problems}} mit Problemen',
      onlyIssues: 'Nur mit Problemen',
      status: {
        available: 'Verfügbar',
        processing: 'Wird verarbeitet',
        not_embeddable: 'Nicht einbettbar',
        region_blocked: 'In der Türkei gesperrt',
        unavailable: 'Entfernt oder privat',
        unknown: 'Noch keine Details',
      },
      problem: {
        not_embeddable:
          'Der Videoeigentümer hat die Wiedergabe auf anderen Websites deaktiviert; in der Storefront ausgeblendet.',
        region_blocked:
          'Das Video kann in der Türkei nicht angesehen werden; in der Storefront ausgeblendet.',
        unavailable:
          'Das Video wurde gelöscht, auf privat gesetzt oder abgelehnt; in der Storefront ausgeblendet. Entfernen oder ersetzen Sie es im Produkt bzw. Beitrag.',
      },
      published: 'Veröffentlicht: {{date}}',
      open: 'Auf YouTube öffnen',
      usedBy: 'Verwendet in:',
      product: 'Produkt: {{name}}',
      post: 'Beitrag: {{name}}',
    },
    ltv: {
      lead: 'Die erwarteten Ausgaben der Kunden in den nächsten 12 Monaten, berechnet aus ihrer Bestellhistorie mit einem nachvollziehbaren Modell (keine KI, kein externer Dienst). Wird mit der RFM-Berechnung (nächtlich) aktualisiert.',
      empty: 'Noch keine berechneten Kundendaten',
      emptyLead: 'Erscheint hier, nachdem RFM im Bereich Kundensegmente berechnet wurde.',
      summaryTitle: 'Zusammenfassung',
      computedAt: 'Zuletzt berechnet',
      customers: 'Kunden',
      modeledOf: 'Prognose für {{modeled}} / {{total}} Kunden',
      total: 'Erwartete Gesamtausgaben in 12 Monaten (Bestandskunden)',
      repeatRate: 'Wiederkaufrate',
      repeatUnknown: 'Keine Prognose für Einmalkäufer (mindestens {{min}} Kunden nötig; derzeit {{count}})',
      repeatValue: '{{rate}} % · mittlerer Abstand (Median) bei Wiederkäufern {{days}} Tage',
      top10: 'Anteil der wertvollsten 10 % an den erwarteten Ausgaben',
      cac: 'Werbekosten pro Neukunde (letzte 90 Tage)',
      cacValue: '{{cac}} pro Neukunde · erwarteter 12-Monats-Wert eines Neukunden {{ltv}}',
      segmentsTitle: 'Nach Segment',
      segment: 'Segment',
      avgHistoric: 'Durchschnittliche bisherige Ausgaben',
      avgPredicted: 'Durchschnittlich erwartet (12 Monate)',
      topTitle: 'Kunden mit dem höchsten erwarteten Wert',
      hiddenName: 'Kunde (Namen für Sie nicht sichtbar)',
      orders: '{{count}} Bestellungen',
      predictedLine: '{{value}} · ~{{orders}} Bestellungen',
      customerCell: 'Prognostizierter Wert (12 Monate)',
      customerCellSub: '~{{orders}} Bestellungen erwartet · das Modell wird im Bereich Kundenwert erklärt',
    },
    settings: {
      statusTitle: 'Status',
      statusLead:
        'KI ist ein kostenpflichtiger externer Dienst. Auch wenn ein Schlüssel eingegeben ist, wird nichts gesendet, bevor Sie ein monatliches Ausgabenlimit festlegen und ausdrücklich zustimmen.',
      on: 'An',
      off: 'Aus',
      enabledBy: 'Eingeschaltet von {{name}} am {{date}}',
      textProvider: 'Text (Anthropic Claude)',
      imageProvider: 'Bilder (OpenAI Images)',
      toIntegrations: 'Schlüssel im Bereich Integrationen eingeben',
      enable: 'KI einschalten',
      disable: 'Ausschalten',
      disabled: 'KI ausgeschaltet. Es entstehen keine weiteren Kosten, sofern keine Anfrage mehr läuft.',
      enableTitle: 'KI einschalten',
      enableLead:
        'Nach dem Einschalten können berechtigte Benutzer Entwürfe erzeugen, und der Anbieter (Anthropic/OpenAI) berechnet jede Anfrage. Das System stoppt beim Monatslimit.',
      enableLimit: 'Monatliches Ausgabenlimit (USD)',
      enableLimitHint:
        'Sobald die geschätzten Ausgaben diesen Betrag erreichen, werden keine neuen Anfragen gesendet. Mindestens 1 USD.',
      enableAck:
        'Ich bestätige, dass es sich um einen kostenpflichtigen Dienst handelt, die Kosten an den Anbieter gezahlt werden und die Ausgaben innerhalb des Limits bleiben.',
      enableProviderNote:
        'Wir empfehlen, auch in der Konsole des Anbieters (Anthropic Console, OpenAI-Limits) ein Ausgabenlimit festzulegen: Das Limit des Systems ist eine Schätzung.',
      enableSubmit: 'Ich stimme zu, einschalten',
      enabled: 'KI eingeschaltet.',
      monthTitle: 'Dieser Monat',
      spent: 'Geschätzte Ausgaben',
      spentOf: '{{spent}} / {{limit}}',
      noLimit: 'Kein Limit festgelegt',
      requests: 'Anfragen',
      requestsToday: 'Heute {{count}} / {{limit}}',
      estimateNote:
        'Die Beträge sind Schätzungen aus Token-Zahlen und der Preistabelle unten; maßgeblich ist die Rechnung des Anbieters.',
      configTitle: 'Einstellungen',
      monthlyLimit: 'Monatliches Ausgabenlimit (USD)',
      dailyLimit: 'Tägliches Anfragelimit',
      textModel: 'Textmodell',
      lightModel: 'Modell für kurze Aufgaben',
      lightModelHint: 'Für kurze Aufgaben wie Titel, Meta-Beschreibungen und Alt-Texte (günstiger).',
      imageModel: 'Bildmodell',
      imageQuality: 'Bildqualität',
      imageQualities: { low: 'Niedrig', medium: 'Mittel', high: 'Hoch' },
      imageReserve: 'Obergrenze pro Bild (USD)',
      imageReserveHint:
        'Wird vor jeder Bildanfrage reserviert; gilt als Kosten, wenn der Anbieter keine Token-Zahlen meldet.',
      supportDrafts: 'Kundennachricht für Support-Antwortentwürfe senden',
      supportDraftsHint:
        'E-Mail-Adressen, Telefonnummern, Ausweisnummern, IBANs und Kartennummern werden maskiert; Namen und Adressen lassen sich nicht entfernen. Aktualisieren Sie vorher mit Ihrem Anwalt das Verzeichnis der Datenübermittlungen ins Ausland (KVKK) und Ihre Datenschutzhinweise.',
      save: 'Einstellungen speichern',
      saved: 'Einstellungen gespeichert.',
      pricesTitle: 'Preistabelle',
      pricesLead:
        'Die Standardpreise wurden am {{date}} von den Preisseiten der Anbieter übernommen. Aktualisieren Sie sie hier, wenn ein Anbieter seine Preise ändert.',
      model: 'Modell',
      kind: 'Typ',
      kinds: { text: 'Text', image: 'Bild' },
      inputPrice: 'Eingabe / 1 Mio. Token',
      outputPrice: 'Ausgabe / 1 Mio. Token',
      custom: 'Eigener Preis',
      unknownPrice: 'Kein Preis',
      editPrice: 'Preis bearbeiten',
      resetPrice: 'Auf Standard zurücksetzen',
      priceTitle: 'Preis von {{model}}',
      priceSaved: 'Preis gespeichert.',
      usageTitle: 'Nutzung',
      usageLead: 'Jede an einen Anbieter gesendete Anfrage. Prompts und Antworten werden nicht gespeichert.',
      month: 'Monat',
      totals: '{{requests}} Anfragen · {{ok}} erfolgreich · {{errors}} Fehler · {{cost}}',
      tokens: '{{input}} Eingabe- / {{output}} Ausgabe-Token',
      byPurpose: 'Nach Zweck',
      purpose: 'Zweck',
      cost: 'Kosten',
      recent: 'Letzte Anfragen',
      when: 'Zeitpunkt',
      user: 'Benutzer',
      status: 'Ergebnis',
      masked: 'Maskiert',
      claims: 'Gesundheitsaussagen',
      noUsage: 'Keine Anfragen in diesem Monat.',
      system: 'System',
    },
  },
  integrationMessages: {
    youtube_ok: 'Schlüssel verifiziert (Regionsliste gelesen; 1 Kontingenteinheit, kostenlos).',
    youtube_key_format: 'Falsches API-Schlüsselformat (beginnt mit „AIza“, 39 Zeichen).',
    youtube_key_invalid: 'Google hat diesen API-Schlüssel nicht akzeptiert.',
    youtube_key_restricted:
      'Eine Browser-/App-Einschränkung des Schlüssels verhindert die Nutzung durch den Server (verwenden Sie eine IP-Einschränkung).',
    youtube_api_disabled: 'YouTube Data API v3 ist im Google-Cloud-Projekt nicht aktiviert.',
    youtube_quota: 'Das YouTube-Tageskontingent ist aufgebraucht.',
    youtube_unreachable: 'YouTube ist nicht erreichbar.',
    ai_text_ok: 'Schlüssel verifiziert (Modellliste gelesen; keine Kosten).',
    ai_image_ok: 'Schlüssel verifiziert (Modellliste gelesen; keine Kosten).',
    ai_invalid_key: 'Der Anbieter hat den API-Schlüssel abgelehnt.',
    ai_invalid_settings: 'Der API-Schlüssel ist leer oder fehlerhaft.',
    ai_provider_rate_limited: 'Ratenlimit des Anbieters erreicht; versuchen Sie es gleich erneut.',
    ai_provider_overloaded: 'Der Anbieter ist ausgelastet; versuchen Sie es gleich erneut.',
    ai_provider_rejected: 'Der Anbieter hat die Anfrage abgelehnt.',
    ai_provider_timeout: 'Der Anbieter hat nicht rechtzeitig geantwortet.',
    ai_provider_unreachable: 'Der Anbieter ist nicht erreichbar.',
    ai_provider_bad_response: 'Die Antwort des Anbieters konnte nicht gelesen werden.',
  },
  integrations: {
    ai_text: {
      name: 'KI (Text) — Anthropic Claude',
      description:
        'Produktbeschreibungen, Artikel- und E-Mail-Entwürfe, Übersetzung und Copilot. Kostenpflichtig; die Nutzung erfordert die Freigabe durch den Inhaber und ein Monatslimit in den KI-Einstellungen.',
    },
    ai_image: {
      name: 'KI (Bilder) — OpenAI Images',
      description:
        'Titel- und Inhaltsbilder für Artikel. Kostenpflichtig; die Nutzung erfordert die Freigabe durch den Inhaber und ein Monatslimit in den KI-Einstellungen.',
    },
    youtube: {
      name: 'YouTube Data API',
      description:
        'Details zu Produkt- und Blogvideos (Vorschaubild, Dauer, Verfügbarkeit): strukturierte Videodaten in der Storefront, Ausblenden und Kennzeichnen entfernter Videos. Nur Lesezugriff, API-Schlüssel; kostenloses Tageskontingent.',
    },
  },
  permissions: {
    'ai.generate': 'Entwürfe mit KI erzeugen (kostenpflichtiger Dienst)',
    'ai.usage.read': 'KI-Nutzung und -Kosten anzeigen',
    'ai.settings.manage': 'KI ein-/ausschalten und Ausgabenlimit festlegen',
  },
  permissionModules: { ai: 'KI' },
  integrationFields: { organizationId: 'Organisations-ID (optional, org-…)' },
  auditActions: {
    'seo.keywords_clustered': 'Keyword-Cluster übernommen',
    'catalog.product.merchant_title': 'Google-Produkttitel geändert',
    'file.ai_generated': 'Bild mit KI erzeugt',
    'file.provenance_update': 'Bildquelle und Lizenz aktualisiert',
    'article_project.create': 'Artikelprojekt erstellt',
    'article_project.update': 'Artikelprojekt aktualisiert',
    'article_project.archive': 'Artikelprojekt archiviert',
    'article_project.exported': 'Artikelprojekt in den Blog übertragen',
    'article_project.ai_step': 'KI-Schritt im Artikelprojekt',
    'article_project.sources_checked': 'Artikelquellen geprüft',
    'article_project.duplicates_checked': 'Dublettenprüfung des Artikels durchgeführt',
    'ai.enabled': 'KI eingeschaltet',
    'ai.disabled': 'KI ausgeschaltet',
    'ai.settings_update': 'KI-Einstellungen aktualisiert',
    'recommendations.settings_update': 'Empfehlungseinstellungen aktualisiert',
    'recommendations.recomputed': 'Empfehlungen neu berechnet',
    'forecast.settings_update': 'Einstellungen der Bedarfsprognose aktualisiert',
    'forecast.variant_update': 'Prognoseeinstellung der Variante aktualisiert',
  },
};
